import React, { useEffect, useState } from 'react';
import { registerFetchInterceptor } from '../../infrastructure/interceptor';
import { LoadingOverlay } from '../loading-overlay';

const Loader = () => {
  const [loadingIndicator, setLoadingIndicator] = useState(false);
  const [counter, setCounter] = useState(0);

  const startFetch = () => {
    setCounter(prevValue => prevValue + 1);
  };

  const finishFetch = () => {
    setCounter(prevValue => prevValue - 1);
  };

  useEffect(() => {
    const unregister = registerFetchInterceptor(startFetch, finishFetch);
    // registerFetchInterceptor returns unregister function to be called on cleanup therfoe it is returned by useEffect
    return () => {
      unregister();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setLoadingIndicator(counter > 0);
  }, [counter]);

  return loadingIndicator && <LoadingOverlay />;
};

export default Loader;
